module.exports = __webpack_public_path__ + "static/media/le-potager-regal.4e18c374.jpg";